import React from "react";
import { PanelLeftOpen } from "lucide-react";
import MarketHeroAvatar from "../../../../components/market/MarketHeroAvatar";
import AppLiveClock from "../../ui/AppLiveClock";
import { useMediaQuery } from "../../../hooks/useMediaQuery";
import { MARKET_TYPES } from "../../../utils/bondPredictHelpers";

const BPD_CHROME_CLOCK_BREAKPOINT = "(min-width: 1025px)";

const MarketDetailShell = ({
  market,
  title,
  meta = [],
  onOutcomeMenuToggle,
  outcomeMenuOpen = false,
  selectedOutcomeLabel,
}) => {
  const showClock = useMediaQuery(BPD_CHROME_CLOCK_BREAKPOINT);
  const showMeta = meta.length > 0;
  const renderMetaItem = (item) => {
    const text = String(item || "").trim();
    const match = text.match(/^(.+?)\s+([A-Za-z]+)$/);
    if (!match) {
      return (
        <span key={text} className="bpd-chrome-meta-chip tabular-nums">
          {text}
        </span>
      );
    }
    return (
      <span key={text} className="bpd-chrome-meta-chip tabular-nums">
        <strong>{match[1]}</strong>
        <em>{match[2]}</em>
      </span>
    );
  };

  return (
    <header className="bpd-chrome">
      <div className="bpd-chrome-row">
        <div className="bpd-chrome-left">
          {market && market.type !== MARKET_TYPES.HEAD_TO_HEAD ? (
            <MarketHeroAvatar
              market={market}
              label={title}
              size={36}
              className="bpd-chrome-avatar"
            />
          ) : null}

          <div className="bpd-chrome-main">
            <h1 className="bpd-chrome-title bondhouse-name" title={title}>
              {title || "Market"}
            </h1>
            {showMeta ? (
              <div className="bpd-chrome-meta" aria-label="Market summary">
                {meta.map(renderMetaItem)}
              </div>
            ) : null}
          </div>
        </div>

        {showClock || onOutcomeMenuToggle ? (
          <div className="bpd-chrome-trail app-chrome-clock-center">
            {onOutcomeMenuToggle ? (
              <button
                type="button"
                className={`bpd-chrome-menu-btn${outcomeMenuOpen ? " bpd-chrome-menu-btn-active" : ""}`}
                onClick={onOutcomeMenuToggle}
                aria-label="Choose market outcome"
                aria-expanded={outcomeMenuOpen}
                title="Choose outcome"
              >
                <PanelLeftOpen size={16} strokeWidth={2.3} />
                <span>{selectedOutcomeLabel || "Outcomes"}</span>
              </button>
            ) : null}
            {showClock ? (
              <AppLiveClock className="bpd-chrome-clock app-chrome-clock" />
            ) : null}
          </div>
        ) : null}
      </div>
    </header>
  );
};

export default MarketDetailShell;
